import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../components/ui/alert-dialog';
import { Clock, LogOut } from 'lucide-react';

const IdleTimeoutWarning = ({ isOpen, remainingTime, onStayLoggedIn, onLogout }) => {
  const minutes = Math.floor(remainingTime / 60000);
  const seconds = Math.floor((remainingTime % 60000) / 1000);
  
  const formatTime = () => {
    if (minutes > 0) {
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${seconds} seconds`;
  };

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-600">
            <Clock className="h-5 w-5 animate-pulse" />
            Session Timeout Warning
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              You have been inactive for a while. For security reasons, you will be automatically logged out.
            </p>
            <div className="flex items-center justify-center py-4">
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-600 tabular-nums">
                  {formatTime()}
                </div>
                <p className="text-sm text-gray-500 mt-1">remaining</p>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              Click "Stay Logged In" to continue your session, or "Logout Now" to end your session immediately.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel 
            onClick={onLogout}
            className="bg-gray-100 hover:bg-gray-200"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Logout Now
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onStayLoggedIn}
            className="bg-green-600 hover:bg-green-700"
          >
            Stay Logged In
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default IdleTimeoutWarning;
